import styled from 'styled-components';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { darken } from 'polished';

export const Container = styled.div`
  margin: 0 auto;
  width: 100%;
  max-width: 1280px;
  position: relative;

  .support {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    align-items: center;
    text-align: center;
    margin: 0 1rem;
    color: #fff;
    a.contact {
      img {
        margin-right: 0.3rem;
      }
      display: flex;
      align-items: center;
      padding: 0.5rem;
      font-weight: 600;
      color: #fff;
    }
  }
  a.survey-link {
    color: inherit;
  }
  .saluboxVersion {
    opacity: 0.8;
    color: #fff;
    margin-top: 1.8rem;
    margin-bottom: 1.8rem;
  }
  .version {
    opacity: 0.5;
  }
  span {
    padding: 0.5rem;
  }
`;

export const StyledTabs = styled(Tabs)`
  margin: 10px 0 -5px;
`;

export const StyledTab = styled(Tab)`
  &:not(:first-child) {
    margin-left: -16px;
  }
  ${props =>
    props.isSelected
      ? `
    font-weight: 900;
    text-shadow: 1px 1px 19px;
    color: ${props => props.theme.palette.text.secondary};
  `
      : ''}
  z-index: ${props => 9 - props.index};
`;

export const PageContent = styled(Paper)`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: ${props => (props.isWideView ? '0 11px 11px 11px' : '11px')};
  z-index: 99;
  position: relative;
  padding: 1rem;
  margin-bottom: 3rem;
`;
